/**
 * Whether this person also has a Tab Service portal account.
 *
 * The portal says so when it hands somebody across: only its own E-Filing entry adds the
 * marker, and the sign-in path for somebody who has e-filing and nothing else does not. The
 * answer is kept in this browser so it survives a reload.
 *
 * It is a hint, not a permission. All it decides is whether a link back to the portal appears
 * in the account menu; forging it would show a link to a sign-in page, and nothing more. The
 * portal itself decides what anyone may do when they arrive.
 */
const KEY = 'tabfile.portal-account';

export function rememberPortalAccount(has: boolean): void {
  try {
    if (has) localStorage.setItem(KEY, '1');
    else localStorage.removeItem(KEY);
  } catch {
    // Private browsing, or storage turned off. The link is not worth an error.
  }
}

export function hasPortalAccount(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}
